import styled from 'styled-components'
import { color } from '../../GlobalStyle'
export const ActionsDiv = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  padding: 10px 4px;
`
export const PdvImport = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  p {
    font-weight: bold;
    padding-right: 5px;
  }
`
export const TableSales = styled.table`
  width: 100%;
  border-collapse: collapse;
  thead tr {
    background: ${(props) => props.theme.background_secundary};
  }
  thead th:hover {
    background: #d9dbdd;
  }
  ,
  td,
  th {
    border-bottom: 1px solid rgba(217, 219, 221, 0.5);
    text-align: start;
  }

  th {
    padding: 12px;
  }
  ,
  td {
    padding: 12px 10px;
  }

  .green {
    box-sizing: border-box;
    color: ${(props) => props.theme.brand};
    background-color: rgba(56, 211, 92, 0.1) !important;
    box-shadow: inset 0 0 0 0.15rem rgba(56, 211, 92, 0.2);
    outline: 0 none;
  }
  .greenText {
    color: ${(props) => props.theme.brand};
    font-weight: bold;
  }
`
export const Tag = styled.span`
  font-size: 17px;
  color: ${(props) => (props.green ? props.theme.brand : color.cancel)};
`
export const ColumnDiv = styled.div`
  display: flex;
  align-items: center;

  span {
    display: flex;
    align-items: center;
  }

  svg {
    font-size: 20px;
    cursor: pointer;
    margin-left: 4px;
  }
`

export const ContainerPopUp = styled.div`
  position: relative;
`
export const ModalPopUp = styled.div`
  position: absolute;
  background: #ffffff;
  color: #495057;
  border: 0 none;
  border-radius: 6px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  min-width: 12.5rem;
  left: -10px;
  top: 10px;
  padding: 10px;
`

export const FlexDiv = styled.div`
  margin-top: 30px;
  display: flex;
  gap: 10px;
`
